import PropTypes from "prop-types";
import * as React from "react";
import QuickActionTile from "../templates/quickActionTile";
import SingleLinkTile from "../templates/singleLinkTile";
import { quickActionTilesMap } from "../tilesMap";

const LxpInfoTile = ({ id }) => {
    return (
        <QuickActionTile id={id}>
            <SingleLinkTile
                link={GLOBAL_CONFIG.lmsLearningPortal}
                title={quickActionTilesMap[id].name}
                linkText={quickActionTilesMap[id].description}
            />
        </QuickActionTile>
    );
};

LxpInfoTile.propTypes = {
    id: PropTypes.string.isRequired,
};

export default LxpInfoTile;
